window.addEventListener('load', () => {
  const navTabs = document.querySelectorAll('[data-tab-nav]');

  navTabs.forEach((navTab) => {
    const navTabGroupTarget = navTab.getAttribute('data-tab');
    const navTabItems = navTab.querySelectorAll('[data-tablink]');
    const tabContentWrapper = document.querySelector(`${'[data-tab-wrapper][data-tab="'}${navTabGroupTarget}${'"]'}`);
    const tabContentElems = tabContentWrapper.querySelectorAll('[data-tab-content]');

    // Close all tabs
    function closeTabContents() {
      navTabItems.forEach((elem) => {
        elem.classList.remove('is-active');
      });
      tabContentElems.forEach((contentElem) => {
        contentElem.classList.remove('is-active');
      });
    }

    // Open specific tab
    navTabItems.forEach((el, index) => {
      el.addEventListener('click', () => {
        closeTabContents();
        const targetTabContent = tabContentWrapper.querySelectorAll('[data-tab-content]')[index];

        setTimeout(() => {
          targetTabContent.classList.add('is-active');
        }, 100);

        el.classList.add('is-active');
      });
    });
  });
});
